import axios from 'axios'
const PodcastApi = {
    async getSingle(id) {
       const podcast = await axios.get('/podcast/' + id)
       return podcast
    }
}

export default PodcastApi